import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

export const LoaderWithText = ({
  text,
  iconClassName,
  className,
  textClassName,
}: {
  text?: string;
  iconClassName?: string;
  textClassName?: string;
  className?: string;
}) => {
  return (
    <div className={cn("flex flex-col gap-1 items-center justify-center font-inter", className)}>
      <Spinner className={iconClassName || "size-4"} />
      <span className={cn("text-sm text-center", textClassName)}>{text || "Loading..."}</span>
    </div>
  );
};
